import React from 'react'
import { ColumnDef } from './table-helpers'
import { NumberFormatter, Table, Text } from '@mantine/core'
import { useAppState } from '../../../../../../hooks/redux'

type RowProps = {
  match: Record<string, any>
  handleMatchSelect: (match: Record<string, any>) => void
  hoveredRowId: number
  setHoveredRowId: React.Dispatch<React.SetStateAction<number | null>>
  columnsDef: ColumnDef[]
  debugEnabled: boolean
}

const Monetary = ({ value, symbol, monetaryDivisor, monetaryRounding }: { value: number, symbol: string, monetaryDivisor?: number, monetaryRounding?: number }) => 
  <NumberFormatter prefix={symbol} value={(value / (monetaryDivisor ?? 1)).toFixed(monetaryRounding ?? 2)} thousandSeparator decimalScale={monetaryRounding ?? 2} />

export const TableRow = ({ match, columnsDef, handleMatchSelect, hoveredRowId, setHoveredRowId, debugEnabled }: RowProps) => {
  const { session: { currencies, monetary_divisor, field_formatting: { monetary_rounding }} } = useAppState()
  const displayCell = (column: ColumnDef) => {
    const matchValue = match[column.fieldCode]
    if (column.customRender) return column.customRender(match, column)
    if (column.isMonetary && matchValue) {
      const currencyCode = match.currency
      const currencySymbol = currencies.find(c => c.code === currencyCode)?.symbol
      return <Monetary value={match[column.fieldCode]} symbol={currencySymbol || ''} monetaryRounding={monetary_rounding} monetaryDivisor={monetary_divisor} />
    }
    if (matchValue) return matchValue
    return ''
  }

  return (
    <Table.Tr
      style={{ cursor: debugEnabled ? 'pointer' : 'inherit', backgroundColor: match.match_id === hoveredRowId ? 'lightGray' : 'transparent' }}
      onClick={() => handleMatchSelect(match)}
      onMouseEnter={() => setHoveredRowId(match.match_id)}
      onMouseLeave={() => setHoveredRowId(null)}
    >
      {columnsDef.map((col, idx) => (
        <Table.Td pl={idx === 0 ? 30 : 0}>
          <Text style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
            { displayCell(col) }
          </Text>
        </Table.Td>
      ))}
    </Table.Tr>
  )
}
